var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('footer',{staticClass:"footer d-flex flex-column flex-md-row align-items-center justify-content-between px-4 py-3 border-top small"},[_c('p',{staticClass:"text-muted mb-1 mb-md-0"},[_vm._v("Copyright © 2024 "),_c('a',{attrs:{"href":"#"}},[_vm._v("Bert")])])])])
}]

export { render, staticRenderFns }